class TabSelect extends HTMLElement {
  constructor() {
    super();

    const tabTriggers = this.querySelectorAll('.tabs__trigger-item');
    const tabContents = this.querySelectorAll('.tabs__content');

    tabTriggers.forEach((trigger) => {
      const triggerIndex = trigger.dataset.index;

      trigger.addEventListener('click', () => {
        const content = this.querySelector(`#tabs__content-${triggerIndex}`);
        trigger.setAttribute('data-selected', '');
        content.setAttribute('data-selected', '');

        tabTriggers.forEach((t) => {
          if (t.dataset.index !== triggerIndex) {
            t.removeAttribute('data-selected');
          }
        });
        tabContents.forEach((c) => {
          if (c.id !== content.id) {
            c.removeAttribute('data-selected');
          }
        });
      });
    });
  }
}

customElements.define('tab-select', TabSelect);
